import { GoogleMap, HereMap, Map } from 'common/utils/Map';
import { PolylineOptions } from '../../types';

import { GooglePolyline } from './GooglePolyline';
import { HerePolyline } from './HerePolyline';

export const polylineFactory = (map: Map, options?: PolylineOptions) => {
  if (map instanceof GoogleMap) {
    return new GooglePolyline(map, options);
  }

  if (map instanceof HereMap) {
    return new HerePolyline(map, options);
  }

  throw Error('There is no a polyline for such a map');
};
